const NotFound = () => {
    return (

        <h1 className="not-found" style={{color: 'yellow'}}>Page Not Found </h1>

    )
}

export default NotFound